import React from 'react'

export default function ConvertIcon()
{
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#A9D342" fill-opacity="0.1"/>
            <g clip-path="url(#clip0_3795_1105)">
                <path d="M16.0597 10.9132C16.6899 11.1482 17.2506 11.5383 17.6902 12.0474C18.1297 12.5565 18.4337 13.1682 18.5741 13.826C18.7146 14.4837 18.6869 15.1663 18.4937 15.8105C18.3004 16.4547 17.9479 17.0398 17.4686 17.5117C16.9893 17.9835 16.3988 18.3269 15.7516 18.5101C15.1045 18.6932 14.4216 18.7102 13.7661 18.5596C13.1106 18.4089 12.5037 18.0953 12.0015 17.6479C11.4993 17.2005 11.1181 16.6337 10.893 15.9999M8.66634 7.99992H9.33301V10.6666M15.1397 13.2533L15.6063 13.7266L13.7263 15.6066M13.333 9.33325C13.333 11.5424 11.5421 13.3333 9.33301 13.3333C7.12387 13.3333 5.33301 11.5424 5.33301 9.33325C5.33301 7.12411 7.12387 5.33325 9.33301 5.33325C11.5421 5.33325 13.333 7.12411 13.333 9.33325Z" stroke="#A9D342" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3795_1105">
                    <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
                </clipPath>
            </defs>
        </svg>

    )
}